export default __webpack_public_path__ + "static/media/dropdownArrow.63797c73.svg";